import { useRef, type ReactNode } from 'react';
import { useDocumentClick } from '../../hooks/document';

interface Props {
    top: number;
    left: number;
    renderMenuItems: () => Iterable<ReactNode>;
    closeContextMenu: () => void;
}

const ContextMenu = (props: Props) => {
    const navRef = useRef<HTMLElement>(null);

    useDocumentClick(navRef, props.closeContextMenu, false, true);

    return (
        <nav
            ref={navRef}
            className="context-menu is-open"
            style={{
                top: `${props.top}px`,
                left: `${props.left}px`,
            }}
            id="tabContextMenu"
            data-testid="tab-context-menu"
        >
            <section>{props.renderMenuItems()}</section>
        </nav>
    );
};

export default ContextMenu;
